import styled from '@emotion/styled';
import breakpoints from '../../../theme/material/breakpoints';

export const DesktopWrapper = styled('div')({
  display: 'block',
  [breakpoints.down('sm')]: {
    display: 'none',
  },
});

export const MobileWrapper = styled('div')({
  display: 'none',
  [breakpoints.down('sm')]: {
    display: 'block',
    textAlign: 'center',
  },
});
